export default "__VITE_ASSET__DQVrA8HT__"